import { Component } from '@angular/core';

@Component({
  selector: 'app-platform-card-placeholder',
  templateUrl: './platform-card-placeholder.component.html',
  styleUrls: ['./platform-card-placeholder.component.scss']
})
export class PlatformCardPlaceholderComponent {

}
